export default {
  //----------------------------------
  // Header
  //----------------------------------
  header: {
    artist: {
      firstname: 'Beatrice',
      lastname: 'Bucher',
    },
    navigation: [
      // { label: 'Aktuelles', slug: 'news' },
      { label: 'Werke', slug: 'objects' },
      { label: 'Ausstellungen', slug: 'exhibits' },
      { label: 'Texte', slug: 'texts' },
      { label: 'CV', slug: 'cv' },
      // { label: 'Videos', slug: 'videos' },
      { label: 'Kontakt', slug: 'contact' },
    ],
  },

  //----------------------------------
  // Footer
  //----------------------------------
  footer: {
    address: 'Beatrice Bucher<br/>Tössfeldstrasse 21<br/>8400 Winterthur<br/>Switzerland',
    contacts: [
      { label: '079 479 47 77', url: 'tel:0041794794777' },
      { label: 'beatrice.bucher@bluewin.ch', url: 'mailto:beatrice.bucher@bluewin.ch' },
    ],
    socials: [
      /*
      { channel: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/nicolagrabiele/' },
      { channel: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/nicola.grabiele/' },
      */
    ],
  },

  //----------------------------------
  // Globals
  //----------------------------------
  contact_email: 'beatrice.bucher@bluewin.ch',
};
